<!-- Reading guide bar -->
<div
  *ngIf="settings.readingGuide"
  class="a11y-guide-bar"
  [style.top]="mouseY - 20 + 'px'"
  aria-hidden="true"
></div>

<!-- Stack: fixed bottom-left -->
<div class="a11y-stack" #stack>
  <div class="a11y-widget" [ngClass]="{ 'a11y-widget--open': isOpen }">
    <!-- Overlay backdrop -->
    <div class="a11y-overlay" aria-hidden="true" (click)="toggle()"></div>

    <!-- Trigger -->
    <button
      #trigger
      class="a11y-trigger"
      (click)="toggle()"
      [attr.aria-expanded]="isOpen"
      aria-haspopup="dialog"
      aria-label="Apri widget accessibilità"
    >
      <img
        [src]="settings.darkContrast
          ? (hasAnyActive ? '/assets/a11y/accessibility-icon-dark-checked.svg' : '/assets/a11y/accessibility-icon-dark.svg')
          : (hasAnyActive ? '/assets/a11y/accessibility-icon-light-checked.svg' : '/assets/a11y/accessibility-icon-light.svg')"
        alt=""
        aria-hidden="true"
        width="58"
        height="58"
      />
    </button>

    <!-- Panel -->
    <div
      #panel
      class="a11y-panel"
      role="dialog"
      aria-modal="true"
      aria-label="Impostazioni accessibilità"
      [attr.aria-hidden]="isOpen ? null : 'true'"
      [attr.inert]="isOpen ? null : ''"
      (keydown)="onPanelKeydown($event)"
    >
      <!-- Header -->
      <div class="a11y-panel__header">
        <img loading="lazy" alt="" aria-hidden="true" src="/assets/a11y/Accessibility icon.svg" class="a11y-header-icon" />
        <h2 class="a11y-panel__title">Accessibilità</h2>
        <button #closeBtn class="a11y-panel__icon-btn" (click)="toggle()" aria-label="Chiudi">
          <span class="material-icons" aria-hidden="true">close</span>
        </button>
      </div>

      <!-- Body -->
      <div class="a11y-panel__body">
        <!-- TESTO -->
        <section class="a11y-section">
          <h3 class="a11y-section__label">Testo</h3>
          <div class="a11y-fontsize" role="group" aria-label="Dimensione testo">
            <button class="a11y-fontsize__btn" (click)="decreaseFontSize()" [disabled]="settings.fontSizeLevel <= -2" aria-label="Riduci testo">
              <img loading="lazy" alt="" aria-hidden="true" src="/assets/a11y/a-square-char.svg" style="width: 20px; height: 20px" />
            </button>
            <span class="a11y-fontsize__level" aria-live="polite" aria-atomic="true">{{ fontSizeLevelLabel }}</span>
            <button class="a11y-fontsize__btn" (click)="increaseFontSize()" [disabled]="settings.fontSizeLevel >= 4" aria-label="Aumenta testo">
              <img loading="lazy" alt="" aria-hidden="true" src="/assets/a11y/a-square-char.svg" style="width: 32px; height: 32px" />
            </button>
          </div>
          <div class="a11y-grid">
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.dyslexia }" [attr.aria-pressed]="'' + settings.dyslexia" (click)="toggleFeature('dyslexia')">
              <img *ngIf="settings.dyslexia" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">font_download</span>
              <span class="a11y-btn__label">Dislessia</span>
            </button>
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.fontWeight }" [attr.aria-pressed]="'' + settings.fontWeight" (click)="toggleFeature('fontWeight')">
              <img *ngIf="settings.fontWeight" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">format_bold</span>
              <span class="a11y-btn__label">Grassetto</span>
            </button>
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.lineHeight }" [attr.aria-pressed]="'' + settings.lineHeight" (click)="toggleFeature('lineHeight')">
              <img *ngIf="settings.lineHeight" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">format_line_spacing</span>
              <span class="a11y-btn__label">Interlinea</span>
            </button>
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.letterSpacing }" [attr.aria-pressed]="'' + settings.letterSpacing" (click)="toggleFeature('letterSpacing')">
              <img *ngIf="settings.letterSpacing" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">text_fields</span>
              <span class="a11y-btn__label">Spaziatura</span>
            </button>
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.textSpacing }" [attr.aria-pressed]="'' + settings.textSpacing" (click)="toggleFeature('textSpacing')">
              <img *ngIf="settings.textSpacing" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">space_bar</span>
              <span class="a11y-btn__label">Spazio testo</span>
            </button>
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.highlightTitles }" [attr.aria-pressed]="'' + settings.highlightTitles" (click)="toggleFeature('highlightTitles')">
              <img *ngIf="settings.highlightTitles" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">title</span>
              <span class="a11y-btn__label">Titoli evidenziati</span>
            </button>
          </div>
        </section>

        <!-- COLORI -->
        <section class="a11y-section">
          <h3 class="a11y-section__label">Colori</h3>
          <div class="a11y-grid">
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.monochrome }" [attr.aria-pressed]="'' + settings.monochrome" (click)="toggleFeature('monochrome')">
              <img *ngIf="settings.monochrome" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">invert_colors</span>
              <span class="a11y-btn__label">Monocromatico</span>
            </button>
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.lowSaturation }" [attr.aria-pressed]="'' + settings.lowSaturation" (click)="toggleFeature('lowSaturation')">
              <img *ngIf="settings.lowSaturation" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">tonality</span>
              <span class="a11y-btn__label">Bassa saturazione</span>
            </button>
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.highSaturation }" [attr.aria-pressed]="'' + settings.highSaturation" (click)="toggleFeature('highSaturation')">
              <img *ngIf="settings.highSaturation" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">palette</span>
              <span class="a11y-btn__label">Alta saturazione</span>
            </button>
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.highContrast }" [attr.aria-pressed]="'' + settings.highContrast" (click)="toggleFeature('highContrast')">
              <img *ngIf="settings.highContrast" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">contrast</span>
              <span class="a11y-btn__label">Alto contrasto</span>
            </button>
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.lightContrast }" [attr.aria-pressed]="'' + settings.lightContrast" (click)="toggleFeature('lightContrast')">
              <img *ngIf="settings.lightContrast" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">light_mode</span>
              <span class="a11y-btn__label">Contrasto chiaro</span>
            </button>
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.darkContrast }" [attr.aria-pressed]="'' + settings.darkContrast" (click)="toggleFeature('darkContrast')">
              <img *ngIf="settings.darkContrast" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">dark_mode</span>
              <span class="a11y-btn__label">Contrasto scuro</span>
            </button>
          </div>
        </section>

        <!-- NAVIGAZIONE -->
        <section class="a11y-section">
          <h3 class="a11y-section__label">Navigazione</h3>
          <div class="a11y-grid">
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.stopAnimations }" [attr.aria-pressed]="'' + settings.stopAnimations" (click)="toggleFeature('stopAnimations')">
              <img *ngIf="settings.stopAnimations" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">animation</span>
              <span class="a11y-btn__label">Blocca animazioni</span>
            </button>
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.bigCursor }" [attr.aria-pressed]="'' + settings.bigCursor" (click)="toggleFeature('bigCursor')">
              <img *ngIf="settings.bigCursor" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">mouse</span>
              <span class="a11y-btn__label">Cursore grande</span>
            </button>
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.highlightLinks }" [attr.aria-pressed]="'' + settings.highlightLinks" (click)="toggleFeature('highlightLinks')">
              <img *ngIf="settings.highlightLinks" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">link</span>
              <span class="a11y-btn__label">Link evidenziati</span>
            </button>
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.readingGuide }" [attr.aria-pressed]="'' + settings.readingGuide" (click)="toggleFeature('readingGuide')">
              <img *ngIf="settings.readingGuide" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">remove</span>
              <span class="a11y-btn__label">Guida lettura</span>
            </button>
            <button class="a11y-btn" [ngClass]="{ 'a11y-btn--on': settings.hideImages }" [attr.aria-pressed]="'' + settings.hideImages" (click)="toggleFeature('hideImages')">
              <img *ngIf="settings.hideImages" loading="lazy" class="a11y-icon-check" alt="" aria-hidden="true" src="/assets/a11y/checkmark-circle-full.svg" />
              <span class="material-icons" aria-hidden="true">hide_image</span>
              <span class="a11y-btn__label">Nascondi immagini</span>
            </button>
          </div>
        </section>

        <!-- Reset bar -->
        <div class="a11y-reset-bar">
          <button class="a11y-reset-btn" (click)="reset()" aria-label="Ripristina impostazioni">
            <img loading="lazy" alt="" aria-hidden="true" src="/assets/a11y/circle-arrow-left.svg" />
            Ripristina
          </button>
        </div>
      </div>

      <!-- Footer logo -->
      <div class="a11y-panel__footer">
        <img
          loading="lazy"
          [src]="settings.darkContrast ? '/assets/img/logo_bn.png' : '/assets/img/ec-logo.svg'"
          alt="Logo Easycode"
          class="a11y-panel__logo"
        />
      </div>
    </div>
  </div>
</div>
